import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportOption } from 'src/app/interfaces/reports.interface';
import { ProductDetailsService } from 'src/app/services/product-details.service';
import { ReportsService } from 'src/app/services/reports.service';
import { finalize } from 'rxjs';
import { NewReportHistoricalDataComponent } from '../common/historical-data/historical-data.component';
import { FunctionsHelper } from 'src/app/helpers/functions';
import { UploadProductDetailsComponent } from './product-details/product-details.component';

@Component({
  selector: 'app-upload-products-list',
  templateUrl: './upload-products-list.component.html',
  styleUrls: ['./upload-products-list.component.scss']
})
export class UploadProductsListComponent implements OnInit {
  @ViewChild('cannotUploadFileModal') cannotUploadFileModal!: ElementRef;
  @ViewChild('uploadProductDetailsComp') uploadProductDetailsComp!: UploadProductDetailsComponent;
  @ViewChild('historicalDataComp') historicalDataComp!: NewReportHistoricalDataComponent;

  selectedFile: File | null = null;
  generatingReport: boolean = false;

  currStep: 'chooseFile' | 'chooseParams' = 'chooseFile';

  reportName: string = '';

  reportOptions: Record<string, ReportOption> = {
    productDetails: {
      title: 'Product Details',
      subtitle: 'Additional Fields',
    },
    historicalData: {
      title: 'Historical Data',
      subtitle: 'Additional Fields',
    },
  };
  reportOptionsKeys: string[] = Object.keys(this.reportOptions);

  constructor(
    public modal: NgbActiveModal,
    private productDetailsService: ProductDetailsService,
    private modalService: NgbModal,
    public reportsService: ReportsService,
    private toastr: ToastrService,
    private _functionsHelper: FunctionsHelper
  ) { }

  ngOnInit(): void { }

  stepBack() {
    if (this.currStep === 'chooseFile') {
      this.reportsService.selectedFeature = null;
    } else {
      this.currStep = 'chooseFile';
      this.selectedFile = null;
    }
  }

  nextStep() {
    this.currStep = 'chooseParams';
  }

  handleFileInput = (event: any) => {
    if (event.target.files.length !== 0) {
      this.selectedFile = event.target.files[0];
      this.processFile();
    }
  };

  handleDropFile = (file: any) => {
    this.selectedFile = file;
    this.processFile();
  };

  processFile = () => {
    this.productDetailsService.newAnalysisFile = this.selectedFile;
    if (this.selectedFile) this.reportName = this._functionsHelper.removeFileExtension(this.selectedFile.name);
    this.productDetailsService.fetchFileRows().then(() => {
      // do something on valid file selection
      this.productDetailsService.changesMade();
    }, (err) => {
      console.log('CSV File Process Error', err);
      this.selectedFile = null;
      this.productDetailsService.newAnalysisFile = null;
      this.openCannotUploadFileModal();
    });
  };

  openCannotUploadFileModal() {
    this.modalService.open(this.cannotUploadFileModal, {
      centered: true,
      modalDialogClass: 'modal-confirm'
    }).result.then(() => {
      this.selectedFile = null;
    }, () => {
      // do nothing
    });
  }

  onChangeValue(reportOption: ReportOption, reportRef: HTMLElement) {
    if (reportOption.checked) {
      $(reportRef).find('.option-content').slideDown(() => {
        $(reportRef).addClass('opened');
      });
    } else {
      $(reportRef).find('.option-content').slideUp(() => {
        $(reportRef).removeClass('opened');
      });
    }
  }

  getReportParams() {
    const reqParams: any = this.uploadProductDetailsComp.getReportRequestParams();
    reqParams.reportName = this.reportName;
    if (this.reportOptions['historicalData'].checked) {
      const historyReqParams: any = this.historicalDataComp.getReportRequestParams();
      reqParams.withHistory = true;
      reqParams.signals = historyReqParams.signals;
      reqParams.dateRange = historyReqParams.dateRange;
    }
    return reqParams;
  }

  generateReport() {
    this.generatingReport = true;
    setTimeout(() => {
      this.productDetailsService.uploadCsv(this.getReportParams())
        .pipe(finalize(() => {
          this.generatingReport = false;
        }))
        .subscribe({
          next: () => {
            this.modal.close('reportGenerated');
          },
          error: (err: any) => {
            console.log('upload error', err);
            if (err && err.error && err.error.statusMessage) {
              this.toastr.error(err.error.statusMessage);
            } else {
              this.toastr.error('Something went wrong. Please try again or contact Administrator.');
            }
          }
        });
    }, 100);
  }

  canGenerateReport(): boolean {
    if (!this.reportName) return false;

    const historyReqParams: any = this.historicalDataComp.getReportRequestParams();
    if (this.reportOptions['historicalData'].checked && (!historyReqParams.signals || !historyReqParams.dateRange)) return false;

    return this.uploadProductDetailsComp.canGenerateReport();
  }

}
